/* eslint-disable no-console */
import { addGallerySwap } from './modules/product-details/gallery-swap';

const productDetails = () => {
  const init = () => {
    addGallerySwap({
      btnSelector: '.product-image-thumb,.product-video-thumb',
      fullSizeImgSelector: '#fullSizeImageWrapper',
      groupSelector: '.product-image-thumb-content',
    });
  };
  init();
};
window.ProductDetailUtils = productDetails;

export default productDetails;
/* eslint-enable no-console */
